module.exports = __webpack_public_path__ + "static/media/47_tn.221c1b92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/47_tn.jpg
// module id = 535
// module chunks = 0